import moment from 'moment';
// eslint-disable-next-line import/no-unresolved,import/extensions
import QrCodeScanner from '../../../components/QrCodeScanner';
import SaleTable from '../saleTable/SaleTable.vue';
import Photo from '../../../components/photo/Photo.vue';


const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export default {
  props: ['action_id', 'id'],
  components: { SaleTable, QrCodeScanner, Photo },
  data() {
    return {
      showPicker: false,
      menu2: false,
      saleID: this.$props.id,
      actionID: this.$props.action_id,
      showHistory: false,
      product: null,
      setProduct: false,
      productPrice: '',
      productFound: null,
      sum: 0,
      checkedPers: false,
      showCard: false,
      quantity: 1,
      barcode: null,
      checkPhoto: {
        base64: '',
        name: '',
      },
      valid: false,
      newSale: {
        action_id: +this.$props.action_id,
        sold_on_local: '',
        sold_on: '',
        positions: [],
        documents: [],
        tickets: [],
        qrcode_t: '',
        qrcode_s: '',
        qrcode_fn: '',
        qrcode_i: '',
        qrcode_fp: '',
        qrcode_n: '1',
        ttn: '',
        customer_inn: '',
      },
      productsList: [],
      isLoading: false,
      scanQrCode: {
        openModal: false,
      },
      showScanCamera: false,
      type: 'individual',
      rules: {
        required: v => !!v || 'Поле должно быть заполнено',
        email: v => (!v.length || pattern.test(v)) || 'Поле E-mail заполнено с ошибками',
        phone: v => (!v || !v.length || v.length >= 17) || 'Номер телефона заполнен не полностью',
        min: v => (!v || v >= 1) || 'Минимальное кол-во 1',
        inn: v => (!v || !v.length || v.length === 10 || v.length === 12) || 'Длина ИНН 10 или 12 символов',
      },
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    action() {
      return this.$store.state.sales.action;
    },
    isLegal() {
      return this.type === 'legal_entity';
    },
    isIndividual() {
      return this.type === 'individual';
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    loading() {
      return this.$store.state.loading;
    },
    isEnabled() {
      return !!this.name && !!this.email && !!this.phone && !!this.message;
    },
    sale() {
      return this.$store.state.sales.sale;
    },
    salesRules() {
      return this.$store.state.sales.salesRules;
    },
    products() {
      const { action } = this.$store.state.sales;
      if (action !== null) {
        return action.products;
      }
      return [];
    },
    validation() {
      // eslint-disable-next-line max-len
      return !!(this.valid && this.newSale.documents.length);
    },
    isEditable() {
      return this.saleID === 'null' || !!(
        this.sale && this.sale.action.is_actual
          && (this.sale.status === 'draft'
              || this.sale.status === 'redo'
          )
      ) || !!(this.sale && this.sale.extra_editable === 'true');
    },
    isShowDraftButton() {
      return !this.$store.state.sales.sale?.id || this.$store.state.sales.sale?.status === 'draft';
    },
  },
  methods: {
    setBarcode(val) {
      this.$nextTick(() => {
        this.barcode = val.replace(/[а-яё]/ig, '');
      });
    },
    /**
     * Получение чека
     * @param qrcode
     */
    detectQr(qrcode) {
      this.$store.getters.axl.post('fns/api/tickets/is-valid', { qrcode: qrcode.toLowerCase(), sale_id: this.saleID })
        .then((response) => {
          const date = moment(response.data.t);
          this.newSale.qrcode_i = response.data.fd;
          this.newSale.qrcode_fn = response.data.fn;
          this.newSale.qrcode_fp = response.data.fp;
          this.newSale.qrcode_n = response.data.n;
          this.newSale.qrcode_s = response.data.s;
          this.newSale.sold_on = date.format('YYYY-MM-DD');
          this.newSale.qrcode_t = date.format('HH:mm');
        })
        .catch(error => this.$store.dispatch('HandleError', error))
        .finally(() => {
          this.scanQrCode.openModal = false;
        });
    },
    stopQrScan(error) {
      this.$store.dispatch('ShowErrorMessage', error);
      this.scanQrCode.openModal = false;
    },
    dateToFormat(date, format = 'DD.MM.YYYY') {
      if (!date) return null;
      return moment(date).format(format);
    },

    formatPrice(val) {
      const numberFormat = Intl.NumberFormat('ru-RU', { style: 'currency', currency: 'RUB' });
      return numberFormat.format(val);
    },

    /** Получить timestamp. */
    setUniqueId() {
      return (new Date()).getTime();
    },
    /** Добавляем продукт в список */
    AddProduct() {
      this.newSale.positions.push({
        listID: this.setUniqueId().toString(),
        article: this.product.article,
        photo_url: this.product.photo_url,
        product_id: this.product.id,
        name: this.product.name,
        quantity: this.quantity,
        cost: this.productPrice,
        bonuses: this.product.bonuses,
        barcode: this.barcode,
      });
      this.product = null;
      this.productPrice = '';
      this.productFound = null;
      this.barcode = null;
      this.quantity = 1;
      this.CalculateSum();
    },
    /**
     * Удалить продукт из списка.
     * @param listID Идентификатор элемента в списке продуктов.
     * @constructor
     */
    DeleteProduct(listID) {
      this.newSale.positions = this.newSale.positions.filter(item => item.listID !== listID);
      this.CalculateSum();
    },
    ChangePosition(listID) {
      const position = this.newSale.positions.find(item => item.listID === listID);
      this.DeleteProduct(listID);
      this.product = this.productsList.find(item => item.id === position.product_id);
      this.productPrice = position.cost;
      this.quantity = position.quantity;
      this.barcode = position.barcode;
    },
    GetSkuName(search, type) {
      const app = this;

      if (search) {
        const payload = { type, search, action_id: this.$props.action_id };
        app.$store.dispatch('sales/GetSkuName', payload)
          .then((data) => {
            app.productFound = data.product || null;
            if (data.product) {
              app.setProduct = true;
              const product = { ...data.product };
              app.product = product;
              this.productsList = [
                ...this.productsList.filter(item => item.id !== product.id), product,
              ];
              app.$store.dispatch('ShowInfo', 'Товар найден');
              app.setProduct = false;
            }
          });
      }
    },
    /**
     * Подсчет суммы баллов за добавленные продукты.
     */
    CalculateSum() {
      this.sum = 0;
      let sum = 0;
      if (this.newSale.positions.length) {
        for (let i = 0; i < this.newSale.positions.length; i += 1) {
          sum += (this.newSale.positions[i].bonuses_formula * this.newSale.positions[i].quantity);
        }
      }
      this.sum = sum;
    },
    preloadSale(data) {
      if (data) {
        this.type = data.type;
        const positions = data.positions.map((p, idx) => ({
          ...p,
          name: p.product.name,
          barcode: p?.barcode?.code || '',
          listID: `${this.setUniqueId().toString()}${p.product.id}${idx}`,
        }));
        this.newSale = {
          ...data,
          positions,
          documents: data.documents.map((i, idx) => ({ ...i, uid: `${this.setUniqueId()}${idx}` })),
        };
      }
    },
    /** Получить список товаров */
    getProducts(field, val = '') {
      const app = this;
      app.isLoading = true;
      app.$store.getters.ax.post('sales/api/sale/get-sku-names', {
        search: val,
        type: 'name',
        action_id: +app.$props.action_id,
      })
        .then((response) => {
          if (response.data.products !== null && Array.isArray(response.data.products)
                && response.data.products.length) {
            app.$data[field] = response.data.products;
          }
          app.isLoading = false;
        });
    },
    /**
     * Метод добавления новой продажи.
     */
    onSubmit(draft = false) {
      const app = this;
      const url = this.saleID !== 'null' ? 'sales/api/sale/update' : 'sales/api/sale/create';
      const payload = {
        ...app.newSale,
        is_draft: draft,
        profile_id: app.user.profile_id,
        type: app.type,
      };


      if (this.saleID !== 'null') {
        payload.sale_id = +this.saleID;
      }

      app.$store.getters.axl.post(url, payload)
        .then(() => {
          app.$router.push('/sales/');
          app.$store.dispatch('ShowInfo', 'Продажа отправлена на проверку');
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        });
    },
  },
  watch: {
    // eslint-disable-next-line func-names
    'newSale.sold_on': function (val) {
      this.newSale.sold_on_local = val && moment(val).format('DD.MM.YYYY');
    },
  },
  created() {
    if (this.actionID !== 'null') {
      this.$store.dispatch('sales/GetAction', {
        action_id: +this.actionID,
      });
    }
    this.getProducts('productsList');
  },
  mounted() {
    const app = this;
    if (app.saleID !== 'null') {
      app.$store.dispatch('sales/GetSale', {
        profile_id: app.user.profile_id,
        sale_id: +app.saleID,
      })
        .then((data) => {
          app.preloadSale(data.sale);
        });
    }
  },
};
